import dynamic from "next/dynamic";

const ReactSwiperCss = dynamic(() => import("./ReactSwiperCss"));

export default ReactSwiperCss;
